// Graph Tab Block JavaScript - Fixed Percentage and Year Handling
(function ($) {

    // Global flag to track if charts are loaded
    var chartsLoaded = false;
    var pendingGraphs = [];

    $(document).ready(function () {

        // Initialize tabs first
        initGraphTabs();

        // Load Google Charts - ONLY corechart package needed
        google.charts.load('current', {
            'packages': ['corechart']
        });

        // Set callback for when charts are loaded
        google.charts.setOnLoadCallback(function () {
            chartsLoaded = true;
            // Draw all active graphs
            drawAllActiveGraphs();
            // Process any pending graphs
            processPendingGraphs();
        });

        // Function to initialize tabs
        function initGraphTabs() {
            $('.st-graph-tab-block').each(function () {
                const $block = $(this);
                const $tabButtons = $block.find('.st-graph-tab__button');
                const $tabPanes = $block.find('.st-graph-tab__pane');

                // Set first tab as active by default
                if (!$tabButtons.hasClass('active')) {
                    $tabButtons.first().addClass('active');
                    $tabPanes.first().addClass('active');
                }

                // Tab click handler
                $tabButtons.on('click', function (e) {
                    e.preventDefault();

                    const $this = $(this);
                    const tabId = $this.data('tab');

                    // Remove active classes
                    $tabButtons.removeClass('active');
                    $tabPanes.removeClass('active');

                    // Add active classes to clicked tab
                    $this.addClass('active');
                    const $activePane = $block.find('#' + tabId).addClass('active');

                    // Draw graph for the active tab
                    drawGraphPane($activePane);
                });

                // Queue initial active pane for drawing
                const $activePane = $block.find('.st-graph-tab__pane.active').first();
                if ($activePane.length) {
                    queueGraphForDrawing($activePane);
                }
            });
        }

        // Queue a graph pane for drawing
        function queueGraphForDrawing($pane) {
            const paneData = {
                $pane: $pane,
                graphId: $pane.data('graph-id'),
                graphType: $pane.data('graph-type'),
                graphTitle: $pane.data('graph-title'),
                showValues: $pane.data('show-values') === 'true'
            };

            if (chartsLoaded) {
                drawGraph(paneData);
            } else {
                pendingGraphs.push(paneData);
            }
        }

        // Process pending graphs
        function processPendingGraphs() {
            pendingGraphs.forEach(function (paneData) {
                drawGraph(paneData);
            });
            pendingGraphs = [];
        }

        // Draw all active graphs
        function drawAllActiveGraphs() {
            $('.st-graph-tab-block').each(function () {
                const $activePane = $(this).find('.st-graph-tab__pane.active').first();
                if ($activePane.length) {
                    const paneData = {
                        $pane: $activePane,
                        graphId: $activePane.data('graph-id'),
                        graphType: $activePane.data('graph-type'),
                        graphTitle: $activePane.data('graph-title'),
                        showValues: $activePane.data('show-values') === 'true'
                    };
                    drawGraph(paneData);
                }
            });
        }

        // Draw graph for a specific pane
        function drawGraphPane($pane) {
            const paneData = {
                $pane: $pane,
                graphId: $pane.data('graph-id'),
                graphType: $pane.data('graph-type'),
                graphTitle: $pane.data('graph-title'),
                showValues: $pane.data('show-values') === 'true'
            };
            drawGraph(paneData);
        }

        // Helper function to parse percentage strings
        function parsePercentage(value) {
            if (typeof value === 'string') {
                // Remove % sign and trim
                value = value.replace('%', '').trim();
                // Convert to number
                const num = parseFloat(value);
                // If it's a percentage, convert to decimal (10% = 0.10)
                return isNaN(num) ? 0 : num / 100;
            }
            // If already a number, check if it's likely a percentage (between -100 and 100)
            if (Math.abs(value) <= 100) {
                return value / 100; // Convert to decimal
            }
            return value; // Return as-is (could be a raw number)
        }

        // Helper function to format percentage for display
        function formatPercentage(value, isDecimal = true) {
            if (typeof value !== 'number') return value;

            // If value is in decimal form (0.1020), multiply by 100 for display
            const displayValue = isDecimal ? value * 100 : value;

            // Format with 2 decimal places
            return displayValue.toFixed(2);
        }

        // Draw graph using pane data
        function drawGraph(paneData) {
            const { $pane, graphId, graphType, graphTitle, showValues } = paneData;

            const $dataContainer = $pane.find('.st-graph-tab__data');
            const headers = JSON.parse($dataContainer.find('.st-graph-tab__headers').text());
            const rows = JSON.parse($dataContainer.find('.st-graph-tab__rows').text());

            if (!headers || !rows || headers.length === 0 || rows.length === 0) {
                console.error('No data found for graph:', graphId);
                return;
            }

            // Check if data contains percentages
            let hasPercentageData = false;
            for (let i = 1; i < headers.length; i++) {
                const sampleValue = rows[0] && rows[0][i];
                if (typeof sampleValue === 'string' && sampleValue.includes('%')) {
                    hasPercentageData = true;
                    break;
                }
            }

            // Get container
            const container = document.getElementById(graphId);
            if (!container) {
                console.error('Container not found:', graphId);
                return;
            }

            // Clear any existing content
            container.innerHTML = '';

            // Create data table with ALL columns including annotations
            const data = new google.visualization.DataTable();

            // Add x-axis column (always first)
            const firstValue = rows[0] && rows[0][0];
            const isFirstColumnNumeric = !isNaN(parseFloat(firstValue));

            // For years, treat as discrete categories if they are integers
            let treatAsDiscrete = false;
            if (isFirstColumnNumeric) {
                const year = parseFloat(firstValue);
                // Check if it's likely a year (4-digit number)
                if (year >= 1000 && year <= 3000 && Math.floor(year) === year) {
                    treatAsDiscrete = true;
                    data.addColumn('string', headers[0]); // Treat as string for discrete display
                } else {
                    data.addColumn('number', headers[0]);
                }
            } else {
                data.addColumn('string', headers[0]);
            }

            // For each data series, we'll create: data column, annotation column, tooltip column
            const seriesCount = headers.length - 1;

            for (let i = 0; i < seriesCount; i++) {
                const headerIndex = i + 1;
                const seriesName = headers[headerIndex];

                // Main data column
                data.addColumn('number', seriesName);

                if (showValues) {
                    // Annotation column (shows value on chart)
                    data.addColumn({
                        type: 'string',
                        role: 'annotation'
                    });

                    // Annotation text column (shows on hover)
                    data.addColumn({
                        type: 'string',
                        role: 'annotationText'
                    });
                }
            }

            // Add rows with data, annotations, and tooltips
            const formattedRows = rows.map(row => {
                const newRow = [];

                // X-axis value
                const xVal = row[0];
                if (treatAsDiscrete) {
                    // For years, use as string for discrete display
                    newRow.push(xVal.toString());
                } else {
                    const numX = parseFloat(xVal);
                    newRow.push(isNaN(numX) ? xVal : numX);
                }

                // Data values and annotations for each series
                for (let i = 1; i < headers.length; i++) {
                    const cell = row[i] || '0';

                    // Parse the value (handle percentages)
                    let value;
                    if (typeof cell === 'string' && cell.includes('%')) {
                        value = parsePercentage(cell);
                    } else {
                        const num = parseFloat(cell);
                        value = isNaN(num) ? 0 : num;

                        // Check if it looks like a percentage (between -100 and 100 but not 0)
                        if (value !== 0 && Math.abs(value) <= 100 && !cell.includes('.')) {
                            // Could be a percentage without % sign
                            value = value / 100;
                        }
                    }

                    // Add data value
                    newRow.push(value);

                    if (showValues) {
                        // Add annotation (visible label)
                        // Format for display
                        let displayValue;
                        if (hasPercentageData || Math.abs(value) <= 1) {
                            // Assume it's a percentage/decimal
                            displayValue = formatPercentage(value, true) + '%';
                        } else {
                            // Raw number
                            displayValue = value.toFixed(1);
                        }
                        newRow.push(displayValue);

                        // Extra annotation text
                        newRow.push(headers[i] + ': ' + displayValue);
                    }
                }

                return newRow;
            });

            data.addRows(formattedRows);

            const responsive = getResponsiveDimensions();

            // Base options for all chart types
            const baseOptions = {
                title: graphTitle || '',
                titleTextStyle: {
                    color: '#0a1934',
                    fontName: 'Gambetta Variable, sans-serif',
                    fontSize: responsive.titleFontSize,
                    bold: false
                },
                width: '100%',
                height: responsive.chartHeight,
                chartArea: responsive.chartArea,
                legend: {
                    position: 'top',
                    alignment: 'end',
                    textStyle: {
                        color: '#0a1934',
                        fontName: 'Lato, sans-serif',
                        fontSize: responsive.legendFontSize
                    }
                },
                colors: ['#00519A', '#06D6A0', '#7D83FF', '#1E96FC', '#D97706'],
                tooltip: {
                    isHtml: false,
                    textStyle: {
                        color: '#0a1934',
                        fontSize: responsive.axisFontSize
                    },
                    showColorCode: true,
                    trigger: 'selection'
                },
                animation: {
                    startup: true,
                    duration: 1000,
                    easing: 'out'
                },
                focusTarget: 'datum',
            };

            // Configure series for annotations if showValues is true
            if (showValues) {
                baseOptions.annotations = {
                    textStyle: {
                        fontSize: responsive.annotationFontSize,
                        color: '#0a1934',
                        bold: true,
                        auraColor: 'none'
                    },
                    stem: {
                        color: 'transparent',
                        length: 0
                    }
                };

                // For bar/column charts, position annotations outside
                if (graphType === 'bar' || graphType === 'column') {
                    baseOptions.annotations.alwaysOutside = true;
                }

                // Configure each series
                baseOptions.series = {};
                for (let i = 0; i < seriesCount; i++) {
                    baseOptions.series[i] = {
                        annotations: {
                            textStyle: {
                                fontSize: responsive.annotationFontSize,
                                color: '#0a1934',
                                bold: true
                            }
                        },
                        // Enable points for line charts
                        pointSize: graphType === 'line' ? 6 : 0,
                        pointShape: 'circle',
                        visibleInLegend: true
                    };
                }
            }

            // Create chart based on type with specific options
            let chart;
            let chartOptions;

            // Determine appropriate vAxis format based on data
            let vAxisFormat = '####.##';
            if (hasPercentageData) {
                vAxisFormat = 'percent';
            }

            switch (graphType) {
                case 'line':
                    chartOptions = {
                        ...baseOptions,
                        hAxis: {
                            title: headers[0],
                            titleTextStyle: {
                                color: '#0A1934',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize,
                                bold: true
                            },
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize
                            },
                            format: treatAsDiscrete ? '' : '####',
                            // For years, show every tick
                            ticks: treatAsDiscrete ? formattedRows.map(row => row[0]) : undefined,
                            slantedText: treatAsDiscrete, // Angle text for discrete values
                            slantedTextAngle: 45,
                            showTextEvery: 1 // Show every label
                        },
                        vAxis: {
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize
                            },
                            format: vAxisFormat,
                            // Set appropriate view window for percentages
                            viewWindow: hasPercentageData ? {

                            } : undefined
                        },
                        lineWidth: 3,
                        pointShape: 'circle',
                        interpolateNulls: true
                    };

                    chart = new google.visualization.LineChart(container);
                    break;

                case 'bar':
                    chartOptions = {
                        ...baseOptions,
                        hAxis: {
                            textStyle: {
                                color: '#0a1934',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize
                            },
                            format: vAxisFormat,
                            viewWindow: hasPercentageData ? {

                            } : undefined
                        },
                        vAxis: {
                            title: headers[0],
                            titleTextStyle: {
                                color: '#0a1934',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize,
                                bold: true
                            },
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize
                            },
                            // For discrete values on vAxis (like years in bar chart)
                            format: treatAsDiscrete ? '' : '####',
                            ticks: treatAsDiscrete ? formattedRows.map(row => row[0]) : undefined
                        },
                        bar: {
                            groupWidth: '75%'
                        },
                        isStacked: false
                    };

                    chart = new google.visualization.BarChart(container);
                    break;

                case 'column':
                    chartOptions = {
                        ...baseOptions,
                        hAxis: {
                            title: headers[0],
                            titleTextStyle: {
                                color: '#0a1934',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize,
                                bold: true
                            },
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.axisFontSize
                            },
                            format: treatAsDiscrete ? '' : '####',
                            ticks: treatAsDiscrete ? formattedRows.map(row => row[0]) : undefined,
                            slantedText: treatAsDiscrete,
                            slantedTextAngle: 45,
                            showTextEvery: 1
                        },
                        vAxis: {
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize
                            },
                            format: vAxisFormat,
                            viewWindow: hasPercentageData ? {

                            } : undefined
                        },
                        bar: {
                            groupWidth: '75%'
                        },
                        isStacked: false
                    };

                    chart = new google.visualization.ColumnChart(container);
                    break;

                default:
                    // Default to line chart
                    chartOptions = {
                        ...baseOptions,
                        hAxis: {
                            title: headers[0],
                            titleTextStyle: {
                                color: '#0a1934',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize,
                                bold: true
                            },
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.axisFontSize
                            },
                            format: treatAsDiscrete ? '' : '####',
                            ticks: treatAsDiscrete ? formattedRows.map(row => row[0]) : undefined,
                            slantedText: treatAsDiscrete,
                            slantedTextAngle: 45
                        },
                        vAxis: {
                            textStyle: {
                                color: '#717173',
                                fontName: 'Lato, sans-serif',
                                fontSize: responsive.legendFontSize
                            },
                            format: vAxisFormat,
                            viewWindow: hasPercentageData ? {
                                min: -1,
                                max: 1
                            } : undefined
                        },
                        curveType: 'function',
                        lineWidth: 3,
                        pointSize: showValues ? 6 : 4
                    };

                    chart = new google.visualization.LineChart(container);
            }

            // Add custom tooltip formatter
            // Format data columns for tooltips and axis labels
            let formatter;
            if (hasPercentageData) {
                formatter = new google.visualization.NumberFormat({
                    pattern: '#.##%'   // converts 0.121 → "12.1%"
                });
            } else {
                formatter = new google.visualization.NumberFormat({
                    pattern: '####.##' // general number formatting
                });
            }
            // Determine step: data columns are every 3 columns if showValues (indices 1,4,7…),
            // otherwise every 1 column (indices 1,2,3…)
            const step = showValues ? 3 : 1;
            for (let i = 1; i < data.getNumberOfColumns(); i += step) {
                formatter.format(data, i);
            }

            // Draw the chart
            try {
                chart.draw(data, chartOptions);

                // Add click event listener for data points
                google.visualization.events.addListener(chart, 'select', function () {
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const item = selection[0];
                        if (item.row != null && item.column != null) {
                            // Calculate which series was clicked
                            let seriesIndex;
                            let columnType;

                            if (showValues) {
                                // With annotations: columns are [x, data1, ann1, tool1, data2, ann2, tool2, ...]
                                seriesIndex = Math.floor((item.column - 1) / 3);
                                columnType = (item.column - 1) % 3; // 0=data, 1=annotation, 2=tooltip
                            } else {
                                // Without annotations: columns are [x, data1, data2, ...]
                                seriesIndex = item.column - 1;
                                columnType = 0;
                            }

                            if (seriesIndex >= 0 && seriesIndex < seriesCount) {
                                const xValue = data.getValue(item.row, 0);
                                const yValue = data.getValue(item.row, item.column);
                                const seriesName = headers[seriesIndex + 1];

                                console.log(`Clicked: ${seriesName} at ${xValue}: ${yValue}`);

                                // Show custom tooltip

                            }
                        }
                    }
                });

            } catch (error) {
                console.error('Error drawing chart:', error);
                container.innerHTML = `
                    <div style="padding: 20px; color: #DC2626; border: 1px solid #DC2626; border-radius: 4px;">
                        <strong>Error loading chart:</strong><br>
                        ${error.message}<br><br>
                        <small>Chart type: ${graphType}<br>
                        Show values: ${showValues}<br>
                        Has percentage data: ${hasPercentageData}</small>
                    </div>
                `;
            }

            // Handle window resize
            const resizeHandler = function () {
                if (chart && typeof chart.draw === 'function') {
                    setTimeout(function () {
                        // Recreate the chart on resize
                        drawGraph(paneData);
                    }, 250);
                }
            };

            // Use debounced resize
            let resizeTimer;
            $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(resizeHandler, 250);
            });

            // Store resize handler for cleanup if needed
            $pane.data('resizeHandler', resizeHandler);
        }

        // Function to show custom tooltip on click


        // Re-initialize when block is added in editor
        if (typeof wp !== 'undefined' && wp.data && wp.data.subscribe) {
            wp.data.subscribe(function () {
                setTimeout(function () {
                    initGraphTabs();
                    if (chartsLoaded) {
                        drawAllActiveGraphs();
                    }
                }, 100);
            });
        }
        function getResponsiveDimensions() {
            const screenWidth = window.innerWidth;
            const isDesktop = screenWidth >= 1024;
            const isTablet = screenWidth >= 768 && screenWidth < 1024;
            const isMobile = screenWidth < 768;

            return {
                isDesktop,
                isTablet,
                isMobile,
                titleFontSize: isDesktop ? 30 : isTablet ? 20 : 16,
                legendFontSize: isDesktop ? 16 : isTablet ? 14 : 12,
                axisFontSize: isDesktop ? 14 : isTablet ? 12 : 10,
                annotationFontSize: 12,
                chartArea: {
                    left: isDesktop ? 60 : isTablet ? 50 : 40,
                    top: isDesktop ? 70 : isTablet ? 60 : 50,
                    width: '100%',
                    height: '80%'
                },
                // Adjust height based on screen size
                chartHeight: isDesktop ? 700 : isTablet ? 700 : 500
            };
        }
    });

})(jQuery);